<template>
  <div>
    <div class="content">
      <div class="block block-rounded">
        <div class="block-content block-content-full user-frm">
          <form>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    placeholder=""
                    name="name"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Description</label>
                  <input
                    type="text"
                    placeholder=""
                    name="name"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label> Number Of Attempts</label>
                  <input
                    type="number"
                    name="email"
                    placeholder=""
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Negative Marks</label>
                  <input
                    type="number"
                    name="mobile"
                    placeholder=""
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Each Question Mark</label>
                  <input
                    type="number"
                    name="mobile"
                    placeholder=""
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Result Status</label>
                  <select name="type" class="form-control">
                    <option>Select Type</option>
                    <option value="active">Active</option>
                    <option value="deactive">Deactive</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label> Duration (mins)</label>
                  <input
                    type="number"
                    name="mobile"
                    placeholder=""
                    class="form-control"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Test Type</label>
                  <select
                  id="questionType"
                    name="type"
                    class="form-control"
                    @change="showAddQuestion()"
                  >
                    <option>Select Type</option>
                    <option value="random">Random</option>
                    <option value="default">Default</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row" id="addQuestionRandom" style="display: none;">
              <div class="col-sm-12 col-md-12 text-right">
                <b-button 
                  variant="success"
                  v-b-modal.addQuestionRadom
                >
                  <i class="fas fa-plus"> </i> Add Question
                </b-button>
              </div>
            </div>
            
            <div class="row" id="addQuestionDefault" style="display: none;">
              <div class="col-sm-12 col-md-12 text-right">
                <b-button 
                  variant="success"
                  v-b-modal.addQuestionDefault
                >
                  <i class="fas fa-plus"> </i> Add Question
                </b-button>
              </div>
            </div>

            <div id="testContents" style="display: none;">
              <!-- Random Table -->
              <div class="col-md-12 my-2">
                Test Contents
                <b-table-simple
                  responsive
                  bordered
                  striped
                  table-class="table-vcenter"
                >
                  <b-thead>
                    <b-tr>
                      <b-th class="text-center">S.NO</b-th>
                      <b-th class="text-center">Parent Topic</b-th>
                      <b-th class="text-center">Topic</b-th>
                      <b-th class="text-center">Subtopic</b-th>
                      <b-th class="text-center">Total Question Count</b-th>
                      <b-th class="text-center">Free Status</b-th>
                      <b-th class="text-center">Actions</b-th>
                    </b-tr>
                  </b-thead>
                  <b-tbody>
                    <b-tr>
                      <b-td class="text-center"> 1</b-td>
                      <b-td class="text-center">Topic 1</b-td>
                      <b-td class="text-center">Name 1</b-td>
                      <b-td class="text-center">Sub topic 1</b-td>
                      <b-td class="text-center">10</b-td>
                      <b-td class="text-center"> Free </b-td>
                      <b-td class="text-center">
                        <b-button class="btn" variant="danger">
                          <i class="fa fa-fw fa-trash"></i>
                        </b-button>
                      </b-td>
                    </b-tr>
                  </b-tbody>
                </b-table-simple>
              </div>

              <div class="text-center">
                <button type="submit" class="btn btn-success ">Save</button>
              </div>
            </div>
          </form>
        </div>

        <!--Add Questions Radom Modal -->

        <b-modal
          id="addQuestionRadom"
          title="Add Question"
          size="xl"
          ref="modalthree"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
        >
          <form action="">
            <div class="row">
              <div class="col-md-6 mb-2">
                <div class="form-group">
                  <label>Parent Topic</label>
                  <select
                    name="type"
                    class="form-control form-control-select"
                    @change="showTopic()"
                  >
                    <option>Select Type</option>
                    <option value="random">UPSC Test</option>
                    <option value="default">Programming Test</option>
                    <option value="default">Puzzele</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 mb-2" id="topic" style="display: none;">
                <div class="form-group">
                  <label>Topic</label>
                  <select
                    name="type"
                    class="form-control form-control-select"
                    @change="showSubTopic()"
                  >
                    <option>Select Type</option>
                    <option value="random">CSAT</option>
                    <option value="default">SAT</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 mb-2" id="subTopic" style="display: none;">
                <div class="form-group">
                  <label>Sub Topic</label>
                  <select
                    name="type"
                    class="form-control form-control-select"
                    @change="showQuestionAvaInfo()"
                  >
                    <option>Select Type</option>
                    <option value="random">CSAT</option>
                    <option value="default">SAT</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 mb-2" id="questionAvainfo" style="display: none;">
                <div class="form-group">
                  <label>Question Availability Info</label>
                  <select
                    name="type"
                    class="form-control form-control-select"
                    @change="showQuestionCount()"
                  >
                    <option>Select Type</option>
                    <option value="random">CSAT</option>
                    <option value="default">SAT</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 mb-2" id="questionCount" style="display: none;">
                <div class="form-group">
                  <label>Question Count</label>
                  <input type="number"
                    class="form-control"
                    v-model="questionCount"
                    @input="showFreeStatus()"
                    />
                </div>
              </div>
              <div class="col-md-6 mb-2" id="freeStatus" style="display: none;">
                <div class="form-group">
                  <label>Fee Status</label>
                  <select
                    name="type"
                    class="form-control form-control-select"
                  >
                    <option>Select Type</option>
                    <option value="free">Free</option>
                    <option value="paid">Paid</option>
                  </select>
                </div>
              </div>
            </div>
            <div>
              <b-button variant="success" @click="showTestContents()" class="float-right ml-2"
                >Insert</b-button
              >
              <b-button
                variant="danger"
                class="float-right"
                @click="addQuestionHideModal"
                >Cancel</b-button
              >
            </div>
          </form>
        </b-modal>

        <!--Add Questions Radom Default -->

        <b-modal
          id="addQuestionDefault"
          title="Add Question"
          size="xl"
          ref="modalthree"
          no-close-on-esc
          no-close-on-backdrop
          hide-footer
        >
          <form action="">
            <div class="row">
              <div class="col-md-6 mb-2">
                <div class="form-group">
                  <label>Parent Topic</label>
                  <select
                    name="type"
                    class="form-control form-control-select"
                    @change="showTopic()"
                  >
                    <option>Select Type</option>
                    <option value="random">UPSC Test</option>
                    <option value="default">Programming Test</option>
                    <option value="default">Puzzele</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 mb-2" id="topic" style="display: none;">
                <div class="form-group">
                  <label>Topic</label>
                  <select
                    name="type"
                    class="form-control form-control-select"
                    @change="showSubTopic()"
                  >
                    <option>Select Type</option>
                    <option value="random">CSAT</option>
                    <option value="default">SAT</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 mb-2" id="subTopic" style="display: none;">
                <div class="form-group">
                  <label>Sub Topic</label>
                  <select
                    name="type"
                    class="form-control form-control-select"
                    @change="showFreeStatus()"
                  >
                    <option>Select Type</option>
                    <option value="random">CSAT</option>
                    <option value="default">SAT</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6 mb-2" id="freeStatus" style="display: none;">
                <div class="form-group">
                  <label>Fee Status</label>
                  <select
                    name="type"
                    class="form-control form-control-select"
                    @change="showChooseQuestion()"
                  >
                    <option>Select Type</option>
                    <option value="free">Free</option>
                    <option value="paid">Paid</option>
                  </select>
                </div>
              </div>

              <div id="chooseQuestion" style="display: none;">
                <div class="col-md-12">
                  <dl class="float-right">
                    <dt class="green"></dt>
                    <dd>Fillups</dd>

                    <dt class="blue"></dt>
                    <dd>Group</dd>

                    <dt class="grey"></dt>
                    <dd>MCQ</dd>
                  </dl>
                </div>
                <div class="col-md-12 my-2  ">
                  <div class="h4 text-capitalize">
                    Select Questions for test
                  </div>
                    <b-list-group>
                      <b-list-group-item class="d-flex justify-content-between align-items-center border-primary">
                        The art of academic writing is not easy to master. It is a formal skill, which requires precision and accuracy, and is perfected by continuous and dedicated practice. Academic writing is the skillful exposition and explanation of an argument, which the writer has carefully researched and developed over a sustained period of time. It is a time-consuming activity and demands patience and perseverance. But the joy of reading and sharing with others, one’s succinctly composed piece of argument, is incomparable. Before beginning to write, the writer must ask himself a few questions – Why am I writing? What is it that I intend to share with others? What purpose will my writing serve? Have I read enough about the topic or theme about which I am going to write? If one is hesitant to answer even one of the aforementioned questions, one better not write at all!
                        <b-button class="float-right" variant="success">
                          <i class="fas fa-check"></i>
                        </b-button>
                      </b-list-group-item>
                    </b-list-group>
                </div>
                <div class="my-2">
                  <b-button variant="success" @click="showTestContents()" class="float-right ml-2"
                    >Insert</b-button
                  >
                  <b-button
                    variant="danger"
                    class="float-right"
                    @click="addQuestionHideModal"
                    >Cancel</b-button
                  >
                </div>
              </div>

            </div>
          </form>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    showAddQuestion() {
      var val = document.getElementById("questionType").value;

    if (val === "random") {
      document.getElementById("addQuestionRandom").style.display = "block";
      document.getElementById("addQuestionDefault").style.display = "none";
    }
    else{
      document.getElementById("addQuestionDefault").style.display = "block";
      document.getElementById("addQuestionRandom").style.display = "none";
    }
    },
    showTopic() {
      document.getElementById("topic").style.display = "block";
    },
    showSubTopic() {
      document.getElementById("subTopic").style.display = "block";
    },
    showQuestionAvaInfo() {
      document.getElementById("questionAvainfo").style.display = "block";
    },
    showQuestionCount() {
      document.getElementById("questionCount").style.display = "block";
    },
    showFreeStatus() {
      document.getElementById("freeStatus").style.display = "block";
    },
    showTestContents() {
      document.getElementById("testContents").style.display = "block";
    },
    showChooseQuestion() {
      document.getElementById("chooseQuestion").style.display = "block";
    },
    addQuestionHideModal() {
      this.$refs.modalthree.hide();
    }
  }
};
</script>

<style scoped>
dl dt {
  display: inline-block;
  width: 20px;
  height: 20px;
  vertical-align: middle;
}
dl dd {
  display: inline-block;
  margin: 0px 10px;
  padding-bottom: 0;
  vertical-align: middle;
}
dl dt.green {
  background: #e5ae67;
}
dl dt.grey {
  background: #343a40;
}
dl dt.blue {
  background: #5179d6;
}
</style>